import { render, staticRenderFns } from "./DialogOpenClose.vue?vue&type=template&id=125b796f&scoped=true&lang=pug"
import script from "./DialogOpenClose.vue?vue&type=script&lang=js"
export * from "./DialogOpenClose.vue?vue&type=script&lang=js"
import style0 from "./DialogOpenClose.vue?vue&type=style&index=0&id=125b796f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b796f",
  null
  
)

export default component.exports